/**
 * Ahirbhutamsha D40 Color Configuration
 * Colors for 8 AHI (actions) and 5 BHUTA (elements)
 */

import { AhiType, BhutaType } from '../components/common/AstrologyChart/DataSections/data/AhirbhutamshaTableData';

/**
 * Color configuration for planet types in D40 table
 */
export interface AhirbhutamshaPlanetColors {
  regular: {
    color: string;
    backgroundColor: string;
    borderColor?: string;
  };
  lagna: {
    color: string;
    backgroundColor: string;
    borderColor?: string;
  };
  hora: {
    color: string;
    backgroundColor: string;
    borderColor?: string;
  };
  chandra: {
    color: string;
    backgroundColor: string;
    borderColor?: string;
  };
  retrograde: {
    color: string;
    backgroundColor: string;
    borderColor?: string;
  };
}

/**
 * Color configuration for 8 AHI (actions)
 * Gradient from creation (green) to control (purple)
 */
export const AHI_COLORS: Record<AhiType, string> = {
  KRTA: '#10b981',      // Creation - Green
  KAVACHA: '#3b82f6',   // Protection - Blue
  YATRA: '#06b6d4',     // Movement - Cyan
  DARSHANA: '#f59e0b',  // Discovery - Amber
  SAMVRITI: '#ef4444',  // Concealment - Red
  BHESHAJA: '#ec4899',  // Healing - Pink
  PRASITI: '#dc2626',   // Attack - Dark Red
  NAYA: '#9333ea'       // Control - Purple
};

/**
 * Color configuration for 5 BHUTA (elements)
 * Traditional elemental colors
 */
export const BHUTA_COLORS: Record<BhutaType, string> = {
  PRITHVI: '#92400e', // Earth - Brown
  APAS: '#1e40af',    // Water - Blue
  AGNI: '#dc2626',    // Fire - Red
  VAYU: '#6b7280',    // Air - Gray
  AKASHA: '#7c3aed'   // Ether - Purple
};

/**
 * Default planet colors for Ahirbhutamsha table
 */
export const DEFAULT_AHIRBHUTAMSHA_PLANET_COLORS: AhirbhutamshaPlanetColors = {
  regular: {
    color: 'black',
    backgroundColor: 'transparent'
  },
  lagna: {
    color: '#e400fd',
    backgroundColor: 'rgb(255,255,255)'
  },
  hora: {
    color: '#0452fa',
    backgroundColor: 'transparent'
  },
  chandra: {
    color: '#13850f',
    backgroundColor: 'transparent'
  },
  retrograde: {
    color: 'black',
    backgroundColor: 'transparent'
  }
};

/**
 * Get color for AHI type
 */
export function getAhiColor(ahiType: AhiType): string {
  return AHI_COLORS[ahiType] || AHI_COLORS.KRTA;
}

/**
 * Get color for BHUTA type
 */
export function getBhutaColor(bhutaType: BhutaType): string {
  return BHUTA_COLORS[bhutaType] || BHUTA_COLORS.PRITHVI;
}

/**
 * Get planet color configuration
 */
export function getAhirbhutamshaPlanetColor(
  planetType: 'regular' | 'lagna' | 'hora' | 'chandra' | 'retrograde',
  colorScheme: AhirbhutamshaPlanetColors = DEFAULT_AHIRBHUTAMSHA_PLANET_COLORS
) {
  return colorScheme[planetType];
}
